import { ChatMessage } from "../types";
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export interface BatchModerationResult {
  flaggedIds: string[];
  explanations: Record<string, string>;
}

export interface NicknameValidationResult {
  isValid: boolean;
  error?: string;
}

/**
 * Uses Gemini to ensure nicknames are safe and private.
 */
export const validateNickname = async (nickname: string, realName: string): Promise<NicknameValidationResult> => {
  try {
    const validateNicknameFn = httpsCallable(functions, 'validateNickname');
    const result = await validateNicknameFn({ nickname, realName });
    return result.data as NicknameValidationResult;
  } catch (error) {
    console.error("Nickname validation failed:", error);
    return { isValid: true };
  }
};

/**
 * Uses Gemini to perform a "Safety Sweep" on a batch of messages.
 */
export const moderateBatch = async (messages: ChatMessage[]): Promise<BatchModerationResult> => {
  if (messages.length === 0) return { flaggedIds: [], explanations: {} };

  try {
    const moderateBatchFn = httpsCallable(functions, 'moderateBatch');
    const result = await moderateBatchFn({ messages });
    return result.data as BatchModerationResult;
  } catch (error) {
    console.error("Batch moderation failed:", error);
    return { flaggedIds: [], explanations: {} };
  }
};
